













import { Vue, Component, Prop } from 'vue-property-decorator'
import { ConfigStore } from '@/store/config'
import { getKey } from '@/utils/key'

@Component
export default class NationalSelect extends Vue {
  @Prop() value!: string
  @Prop() print!: boolean
  getKey = getKey

  get nationals() {
    return ConfigStore.configs.find(a => a.key === 'national')?.value ?? []
  }

  get national() {
    return this.value
  }

  set national(value) {
    this.$emit('update:value', value)
  }
}
